import { render } from "./UI.vue?vue&type=template&id=4c0f0b21"
import script from "./UI.vue?vue&type=script&lang=js"
export * from "./UI.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__